import { useMediaQuery } from '@mui/material';

/** CSS orientation media query — landscape includes square-ish desktop windows. */
export const LANDSCAPE_ORIENTATION_QUERY = '(orientation: landscape)';

/**
 * Portrait vs landscape layout switch for board UIs (explorer side-by-side,
 * trainer controls beside, puzzle controls beside).
 *
 * Prefer this over width breakpoints when the product choice is orientation,
 * not CSS pixel band. Phone landscape is intentionally not special-cased.
 */
export const useLandscapeLayout = (): boolean =>
  useMediaQuery(LANDSCAPE_ORIENTATION_QUERY);
